import { type DropDownProps } from "antd";

import {
    CollapsableControlGroup,
    type ICollapsableControl,
} from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { type EditorControlBreakpointNames } from "commonComponents/btWrappers/editor/core/EditorControlBar/EditorControlBar.types";
import emojiControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/EmojiControl";
import imageControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/ImageControl";
import linkControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/LinkControl";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

interface IEmbedControlGroupProps {
    editor: IEditor;
    editorSize: EditorControlBreakpointNames;
    supportedExtensions: Set<ExtensionName>;
    dropdownPlacement?: DropDownProps["placement"];
}

const embedControls: ICollapsableControl[] = [emojiControl, linkControl, imageControl];

export const isEmbedControlGroupVisible = (
    supportedExtensions: Set<ExtensionName>,
    editor: IEditor,
) => {
    return embedControls.some((embedControl) =>
        embedControl.isControlSupported(supportedExtensions, editor),
    );
};

export const EmbedControlGroup: React.FC<IEmbedControlGroupProps> = ({
    editor,
    supportedExtensions,
    editorSize,
    dropdownPlacement,
}) => {
    return (
        <CollapsableControlGroup
            data-testid="embedControlGroup"
            editor={editor}
            editorSize={editorSize}
            supportedExtensions={supportedExtensions}
            controls={embedControls}
            dropdownPlacement={dropdownPlacement}
            gap={0}
            xs={3}
            sm={3}
            md={3}
            lg={3}
            xl={3}
        />
    );
};
